export const COOKIE_DEFAULT_PATH = '/'
export const COOKIE_MAX_AGE = 31536000
export const COOKIE_MAX_ENCODED_SIZE = 3500
export const LOOKUP_IDENTIFIER_STORAGE_KEY = 'lookupIdentifiers'
export const SITE_SETTINGS_STORAGE_KEY = 'siteSettings'
export const USE_SEARCH_FILTERS_STORAGE_KEY = 'useSearchFilters'
